// extracted by mini-css-extract-plugin
module.exports = {"container":"_navbar-module--container--2LVYO","active":"_navbar-module--active--3ik3L","inner":"_navbar-module--inner--KZsLW","title":"_navbar-module--title--1TdKM"};